import { render, staticRenderFns } from "./DynamicResult.vue?vue&type=template&id=1684100d&lang=pug"
import script from "./DynamicResult.vue?vue&type=script&lang=js"
export * from "./DynamicResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports